export default "__VITE_PUBLIC_ASSET__57222951__"